(function () {
  var COOKIE_NAME = 'wauwow_ref';
  var COOKIE_DAYS = 90;

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref');
  if (ref) {
    setCookie(COOKIE_NAME, ref, COOKIE_DAYS);
  }

  var activeRef = getCookie(COOKIE_NAME);
  if (activeRef) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { wauwow_ref: activeRef } })
    }).catch(function () {});
  }
})();
